import {IQuoteFirestoreDocument} from '../models/quote-firestore.interface';
import {firebaseTimeStampToDate} from '../../../shared/shared-utils/firestore/firestore.utils';
import {Timestamp} from '@angular/fire/firestore';

type IQuoteDateField = IQuoteFirestoreDocument['creationDate'];

/**
 * Resolves the processed/executed timestamp from quote Firestore documents.
 */
export function resolveQuoteProcessedDate(data: IQuoteFirestoreDocument): Date | null {
  const record = data as IQuoteFirestoreDocument & Record<string, IQuoteDateField | undefined>;
  const candidates: (IQuoteDateField | undefined)[] = [
    data.processedDate,
    record.executed,
    record.processed,
    record.completedDate,
    record.dateProcessed,
  ];

  for (const candidate of candidates) {
    const resolved = toQuoteDate(candidate);
    if (resolved) {
      return resolved;
    }
  }

  return null;
}

function toQuoteDate(value: IQuoteDateField | undefined): Date | null {
  if (!value) {
    return null;
  }
  if (value instanceof Date) {
    return value;
  }
  return firebaseTimeStampToDate(value as Timestamp);
}
